/**
 * (wizard-v2, 2026-11-04) Setup wizard v2 (7 steps) + the Getting-started checklist on the Overview.
 * en + zh only (no Malay UI copy: the Malay column falls back to English). Registered in ../en|zh|ms.ts and ../modules.ts.
 */
const ROWS = [["wz.step.profile","Your business","您的店铺"],
  ["wz.step.branch","Location & hours","门店与营业时间"],
  ["wz.step.services","Menu","服务与产品"],
  ["wz.step.team","Team","团队"],
  ["wz.step.checkout","Checkout","收银"],
  ["wz.step.bookings","Bookings & reminders","预约与提醒"],
  ["wz.step.review","Go live","完成并上线"],
  ["wz.essential","About 10 minutes for the essentials. Everything saves as you go — come back any time.","基本设置约 10 分钟。每一步都会自动保存，随时可以回来继续。"],
  ["wz.tax.title","Tax","税"],
  ["wz.tax.my","Malaysia SST: 8 % service tax added on top of your prices.","马来西亚 SST：在价格之外另加 8% 服务税。"],
  ["wz.tax.sg","Singapore GST 9 %, included in your prices.","新加坡 GST 9%，已含在价格中。"],
  ["wz.tax.au","Australia GST 10 %, included in your prices.","澳大利亚 GST 10%，已含在价格中。"],
  ["wz.tax.gb","UK VAT 20 %, included in your prices.","英国 VAT 20%，已含在价格中。"],
  ["wz.tax.us","US sales tax is added at checkout. Enter your combined rate (state + county + city).","美国销售税在结账时另加。请输入合并税率（州 + 县 + 市）。"],
  ["wz.tax.other","Enter the tax you charge, if any. Leave 0 if you don't charge tax.","如需收税请填写税率；不收税请保留 0。"],
  ["wz.tax.notRegisteredGb","I'm not VAT-registered (0 %)","我未登记 VAT（0%）"],
  ["wz.tax.notRegistered","I don't charge {label} (0 %)","我不收 {label}（0%）"],
  ["wz.tax.usServices","Are services taxable in your state?","您所在州对服务征税吗？"],
  ["wz.tax.usServicesHint","Products always use your sales-tax rate. Many states don't tax salon services — switch this on only if yours does.","产品始终按销售税率计税。许多州不对美容类服务征税 —— 只有您所在州征税时才打开。"],
  ["wz.tax.usRate","Combined sales-tax rate (%)","合并销售税率 (%)"],
  ["wz.tax.details","Edit tax details","修改税务细节"],
  ["wz.tax.summary","{label} {rate}% · {mode}","{label} {rate}% · {mode}"],
  ["wz.branch.staffHours","Staff work the shop's hours","员工按营业时间上班"],
  ["wz.branch.staffHoursHint","Bookable staff without a roster get these hours for the next 8 weeks, so customers can book them. Change it any time under Bookings → Roster.","还没有排班的可预约员工，会按这些营业时间自动排好未来 8 周，顾客即可预约。之后可随时在 预约 → 排班 修改。"],
  ["wz.menu.sub","Pick what you sell. Prices are examples in {currency} — change them to yours.","选择您提供的服务与产品。价格为 {currency} 示例，请改成您的价格。"],
  ["wz.menu.tabServices","Services","服务"],
  ["wz.menu.tabProducts","Retail products","零售产品"],
  ["wz.menu.tplTitle","Start from a template","从模板开始"],
  ["wz.menu.tplHint","The sets recommended for your business are ticked.","已为您勾选适合您行业的推荐模板。"],
  ["wz.menu.addTicked","Add ticked templates","添加已勾选的模板"],
  ["wz.menu.added","Added","已添加"],
  ["wz.menu.import","Bring data from my old system","从旧系统导入资料"],
  ["wz.menu.importHint","Upload an export or spreadsheet — the AI import brings in customers, services, products and staff.","上传旧系统导出的文件或表格 —— AI 导入会帮您导入顾客、服务、产品和员工。"],
  ["wz.menu.importClose","Back to the menu","返回服务列表"],
  ["wz.prod.name","Product name","产品名称"],
  ["wz.prod.price","Price ({currency})","价格（{currency}）"],
  ["wz.prod.stock","Stock on hand (optional)","现有库存（可选）"],
  ["wz.prod.add","Add product","添加产品"],
  ["wz.prod.added","{n} products added","已添加 {n} 个产品"],
  ["wz.prod.empty","Optional — add the products you sell at the counter (shampoo, nail polish …).","可选 —— 添加您在柜台销售的产品（洗发水、指甲油等）。"],
  ["wz.prod.list","Your products","您的产品"],
  ["wz.prod.stockOff","Stock counts need the inventory feature; the product is added without stock.","库存功能未开通；产品将不带库存添加。"],
  ["wz.team.level","Level","级别"],
  ["wz.team.levelComm","{level} · {pct}% commission","{level} · 提成 {pct}%"],
  ["wz.team.days","Working days","上班日"],
  ["wz.team.daysHint","Hours follow the shop's opening hours for the next 8 weeks — fine-tune them later in the roster.","上班时间按营业时间排好未来 8 周 —— 之后可在排班中细调。"],
  ["wz.team.branch","Location","门店"],
  ["wz.co.title","Checkout","收银"],
  ["wz.co.sub","How customers pay you, tips, the cash drawer and your receipt.","顾客如何付款、小费、钱箱与收据。"],
  ["wz.co.methods","Accepted payment types","接受的付款方式"],
  ["wz.co.methodsHint","Suggestions for {country}. Rename, reorder or add more later in Settings → Checkout.","以下为 {country} 的常用方式。之后可在 设置 → 收银 改名、排序或添加。"],
  ["wz.co.needOne","Tick at least one payment type.","请至少勾选一种付款方式。"],
  ["wz.co.tips","Tips at checkout","结账时收小费"],
  ["wz.co.tipsUs","Most US customers expect to tip — on by default.","大多数美国顾客习惯给小费 —— 默认开启。"],
  ["wz.co.tipsUk","Many UK salons take tips — recommended.","许多英国店铺都收小费 —— 建议开启。"],
  ["wz.co.tipsHint","Customers pick {presets} or type an amount; tips go to the staff who did the service.","顾客可选 {presets} 或自填金额；小费归做服务的员工。"],
  ["wz.co.recommended","Recommended","推荐"],
  ["wz.co.drawer","Cash drawer","钱箱"],
  ["wz.co.drawerRule","Staff must open the business (count the drawer) before taking cash","收现金前必须先开业（清点钱箱）"],
  ["wz.co.float","Opening float","开业备用金"],
  ["wz.co.floatHint","Cash in the drawer at the start of the day — suggested each time the business is opened.","每天开始时钱箱里的现金 —— 每次开业时自动带出。"],
  ["wz.co.receipt","Receipt footer","收据底部文字"],
  ["wz.co.receiptHint","Printed at the bottom of every receipt. Your address and phone are filled in.","印在每张收据底部。已帮您填好地址和电话。"],
  ["wz.co.stripe","Cards & online payments with Stripe","用 Stripe 收刷卡与在线付款"],
  ["wz.co.stripeBody","Optional. Take cards, payment links and online deposits into your own Stripe account. You connect it after setup.","可选。用您自己的 Stripe 账户收刷卡、付款链接和在线订金。设置完成后再连接。"],
  ["wz.co.stripeCta","I'll connect Stripe","我要连接 Stripe"],
  ["wz.co.stripeChosen","Stripe chosen — connect it in Settings → Payments after setup.","已选择 Stripe —— 设置完成后在 设置 → 收款 连接。"],
  ["wz.co.stripeUndo","Not now","暂不"],
  ["wz.bk.title","Bookings & reminders","预约与提醒"],
  ["wz.bk.sub","Remind customers so they turn up, and set your online booking rules.","提醒顾客按时到店，并设置在线预约规则。"],
  ["wz.bk.reminder","Appointment reminder","预约提醒"],
  ["wz.bk.r24","24 hours before","提前 24 小时"],
  ["wz.bk.r24_2","24 hours and 2 hours before","提前 24 小时和 2 小时"],
  ["wz.bk.r2","2 hours before","提前 2 小时"],
  ["wz.bk.rOff","No reminders","不提醒"],
  ["wz.bk.channels","How reminders are sent","提醒发送方式"],
  ["wz.bk.online","Online booking","在线预约"],
  ["wz.bk.onlineOn","Customers can book online","顾客可以在线预约"],
  ["wz.bk.minNotice","Minimum notice","最少提前"],
  ["wz.bk.cutoff","Customers can cancel up to","顾客最晚可取消时间"],
  ["wz.bk.deposit","Ask for a deposit online","在线预约收订金"],
  ["wz.bk.hoursN","{n} h before","提前 {n} 小时"],
  ["wz.bk.fullBadge","Full","全功能版"],
  ["wz.bk.locked","Online booking with your own booking page is part of the Full plan (or the Website add-on).","带自己预约页的在线预约属于全功能版（或网站附加功能）。"],
  ["wz.bk.lockedCta","Compare plans","比较方案"],
  ["wz.bk.notIncluded","Online booking isn't switched on for this shop.","本店尚未开通在线预约。"],
  ["wz.go.sub","Check the summary, confirm your email and open your shop.","确认摘要和邮箱，然后开始营业。"],
  ["wz.go.app","Get the app for the front desk","在前台设备安装 App"],
  ["wz.go.appHint","Scan with the iPad or iPhone at the front desk, or open the link.","用前台的 iPad 或 iPhone 扫码，或打开链接。"],
  ["wz.go.appStore","Open in the App Store","在 App Store 打开"],
  ["wz.go.android","Android app","安卓 App"],
  ["wz.go.testSale","Make a test sale","做一笔测试销售"],
  ["wz.go.testSaleHint","Goes live and opens the POS — ring up a sale to see your receipt (you can void it afterwards).","开始营业并打开收银台 —— 开一笔单看看收据（之后可作废）。"],
  ["wz.go.trial","Free trial until {date}","免费试用至 {date}"],
  ["wz.go.checkout","{n} payment types · tips {tips}","{n} 种付款方式 · 小费{tips}"],
  ["wz.go.bookings","Reminders: {r}","提醒：{r}"],
  ["wz.on","on","开启"],
  ["wz.off","off","关闭"],
  ["wz.cl.title","Getting started","开店清单"],
  ["wz.cl.progress","{done} of {total} done","已完成 {done} / {total}"],
  ["wz.cl.dismiss","Hide","隐藏"],
  ["wz.cl.expand","Show list","展开"],
  ["wz.cl.collapse","Collapse","收起"],
  ["wz.cl.dismissed","Getting-started checklist hidden.","开店清单已隐藏。"],
  ["wz.cl.restore","Show the getting-started checklist","显示开店清单"],
  ["wz.cl.g.essentials","Essentials","基本"],
  ["wz.cl.g.grow","Grow your business","发展生意"],
  ["wz.cl.g.full","Full plan","全功能版"],
  ["wz.cl.locked","Full plan","全功能版"],
  ["wz.cl.lockedNote","These are part of the Full plan.","以下功能属于全功能版。"],
  ["wz.cl.upgrade","Upgrade in Plan & billing","在 方案与账单 升级"],
  ["wz.cl.markDone","Mark done","标记完成"],
  ["wz.cl.undo","Undo","撤销"],
  ["wz.cl.i.verify_email","Verify your email","验证邮箱"],
  ["wz.cl.i.first_service","Add your first service","添加第一个服务"],
  ["wz.cl.i.add_team","Add your team","添加团队成员"],
  ["wz.cl.i.staff_hours","Set staff working hours (roster)","设置员工上班时间（排班）"],
  ["wz.cl.i.test_sale","Make a test sale","做一笔测试销售"],
  ["wz.cl.i.test_receipt","Print or email a test receipt","打印或发送一张测试收据"],
  ["wz.cl.i.open_business","Open the business / count the cash float","开业 / 清点备用金"],
  ["wz.cl.i.install_app","Install the app on the front-desk device","在前台设备安装 App"],
  ["wz.cl.i.import_customers","Import your customers","导入顾客资料"],
  ["wz.cl.i.packages","Packages & stored value with a top-up bonus","配套与储值（充值赠送）"],
  ["wz.cl.i.loyalty","Loyalty points or member tiers","积分或会员等级"],
  ["wz.cl.i.whatsapp","Connect WhatsApp and review message templates","连接 WhatsApp 并检查消息模板"],
  ["wz.cl.i.referral","Referral programme","推荐计划"],
  ["wz.cl.i.tips","Turn on tips at checkout","开启结账小费"],
  ["wz.cl.i.products","Products & stock","产品与库存"],
  ["wz.cl.i.permissions","Review staff permissions","检查员工权限"],
  ["wz.cl.i.owner_alerts","Owner alerts (new bookings, low stock …)","老板通知（新预约、库存不足等）"],
  ["wz.cl.i.website","Website, booking rules, deposits & cancellation policy","网站、预约规则、订金与取消政策"],
  ["wz.cl.i.own_domain","Use your own domain","使用自己的域名"],
  ["wz.cl.i.payroll","Payroll preset, commission & overtime","薪资方案、提成与加班"],
  ["wz.cl.i.attendance_gps","Attendance clock-in area (GPS)","考勤打卡范围（GPS）"],
  ["wz.cl.i.suppliers","Suppliers & purchase orders","供应商与采购单"],
  ["wz.cl.i.subscriptions","Customer subscriptions","顾客订阅"],
  ["wz.rcpt.moved","Receipt settings moved to Settings → Checkout.","收据设置已移到 设置 → 收银。"],
  ["wz.rcpt.open","Open","前往"],
  ["wz.float.suggested","Suggested opening float","建议备用金"],
  ["wz.pay.statUs","Employer taxes and withholdings (e.g. Social Security, Medicare, FUTA, state taxes) are only calculated as you configure them under Payroll → Settings — presets are examples, verify with your accountant. Income tax is not computed automatically.","雇主税与代扣项目（如社会保障税、联邦医疗保险、FUTA、州税）仅按您在「设置」中配置的项目计算 — 模板仅为示例，请与会计核对。系统不会自动计算所得税。"],
  ["wz.pay.statGb","Employer contributions (e.g. National Insurance, workplace pension) are only calculated as you configure them under Payroll → Settings — presets are examples, verify with your accountant. PAYE income tax is not computed automatically.","雇主供款（如国民保险 NI、职场养老金）仅按您在「设置」中配置的项目计算 — 模板仅为示例，请与会计核对。系统不会自动计算 PAYE 所得税。"],
  ["wz.ot.stat","Overtime is taxable and part of gross pay. It is added to a statutory contribution’s wage base only when that item ticks “Overtime” (Statutory tab).","加班费计入总收入并属应税收入。只有在法定供款项目勾选「加班费」时，才计入该项目的工资基数（法定供款页）。"]] as const;

export type WizardKey = (typeof ROWS)[number][0];
const col = (i: 1 | 2) => Object.fromEntries(ROWS.map((r) => [r[0], r[1 + (i - 1)]])) as Record<WizardKey, string>;
export const taskWZ = { en: col(1), zh: col(2), ms: col(1) };

/** (wizard-v2) payroll statutory note without Malaysian EPF/SOCSO wording for US / UK shops */
export function statutoryNoteKey(regimes: readonly string[] | null | undefined): "payroll.statutory" | "wz.pay.statUs" | "wz.pay.statGb" {
  if (regimes?.includes("us")) return "wz.pay.statUs";
  if (regimes?.includes("gb")) return "wz.pay.statGb";
  return "payroll.statutory";
}
